// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingIndicator-loading-3SEvF","rippleContainer":"LoadingIndicator-rippleContainer-c8J4l","ripple":"LoadingIndicator-ripple-358v5"};